import styled from 'styled-components'

export const Error = styled.span`
  color: red;
  font-size: 13px;
`
